import {
  KHARON_V2_ALLOWED_USER_IDS,
  KHARON_V2_COLUMBIA_COMPANY_ID,
} from './constants.js';

export function isKharonV2Allowed(
  companyId: string | null | undefined,
  userId: string | null | undefined,
): boolean {
  if (companyId !== KHARON_V2_COLUMBIA_COMPANY_ID) return true;
  return !!userId && KHARON_V2_ALLOWED_USER_IDS.has(userId);
}
